const AdminUserDetails = () => {
    return (
        <>
            <h2>Individuele gebruiker details</h2>
        </>
    );
}

export default AdminUserDetails;